export enum InfoTabId {
  workspaceMembers,
  photoAttachments,
  videoAttachments,
  docAttachments,
  filesAttachments,
  audioAttachments,
  voiceAttachments,
}
